document.addEventListener('DOMContentLoaded', function () {

  const waitPopup = setInterval(function () {

    const klaviyoForm = document.querySelector(
      'form[data-testid="klaviyo-form-VnYiri"]'
    );

    if (!klaviyoForm) return;

    const button = klaviyoForm.querySelector(
      'button.klaviyo-form-button'
    );

    const emailField = klaviyoForm.querySelector(
      'input[type="email"]'
    );

    if (button && emailField) {

      clearInterval(waitPopup);

      button.addEventListener('click', function (e) {

        e.preventDefault();

        const email = emailField.value.trim();

        if (!email) return;

        window.location.href =
          '/pages/newsletter?email=' +
          encodeURIComponent(email);

      });

    }

  }, 300);

});